
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/service-suite",
      function () {
        return require("private-next-pages/pricing/service-suite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/service-suite"])
      });
    }
  